<h1 class="mb-4 text-lg tracking-wider text-primary-500 md:text-xl">
  {{ ("impactReport.individualImpactFocus" | transloco).toLocaleUpperCase() }}
</h1>
<div class="mb-16 flex flex-col">
  <h1 class="mb-4 text-lg tracking-wider text-primary-500 md:text-xl">
    {{ ("impactReport.carbonIntensity" | transloco).toLocaleUpperCase() }}
  </h1>
  <div class="flex flex-col md:flex-row">
    <app-intensity-gauge [carbonIntensity]="carbonIntensity" />
    <div class="flex flex-col justify-end pl-8 text-justify">
      <h2 class="text-xl text-alt-primary-100">
        <span class="font-bold">{{ displayedCarbonIntensity }}</span>
        {{ displayedUnit }}
      </h2>
      <p class="pb-1 text-primary-500">
        {{ "impactReport.carbonIntensityDescription" | transloco }}
      </p>
    </div>
  </div>
</div>
